__webpack_require__.p = "/sample-data-refactor/referrals-hub/";